<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L15.5355 8.46447L22 12L15.5355 15.5355L12 22L8.46447 15.5355L2 12L8.46447 8.46447L12 2Z"
      fill="currentColor"
    />
  </svg>
</template>
